import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Col, FormGroup, Label, Row } from "reactstrap";
import Select from "react-select";
import { AvField, AvForm } from "availity-reactstrap-validation";

const Settings = props => {
  const [options, setOptions] = React.useState([]);
  const [delimiter, setDelimiter] = React.useState(",");
  const [modelSelect, setModel] = React.useState(undefined);
  const [encodeSelect, setEncode] = React.useState({
    label: "UTF-8",
    value: "UTF-8",
  });

  React.useEffect(() => {
    let models = [];
    for (let [key, value] of Object.entries(props.data)) {
      models.push({ label: value, value: key });
    }
    setModel(models[0]);
    setOptions(models);

    return () => {
      setDelimiter(",");
      setModel(undefined);
      setEncode({
        label: "UTF-8",
        value: "UTF-8",
      });
    };
  }, [props.data]);

  React.useEffect(() => {
    let errors = 0;

    if (props.activeTab === 2) {
      if (modelSelect !== undefined) {
        let params = {
          id: modelSelect.value,
          delimiter: delimiter,
          fileEncoding: encodeSelect?.value,
        };

        for (let [key, value] of Object.entries(params)) {
          if (value === "" || value === undefined) {
            params[key] = "";
            errors += 1;
          } else {
            params[key] = value;
            errors -= 1;
          }
        }
      }

      if (errors === -3) {
        if (props.file[0].path.split(".").pop() === "csv") {
          props.updateModelData({
            id: modelSelect.value,
            delimiter,
            fileEncoding: encodeSelect.value,
          });
        } else {
          props.updateModelData({
            id: modelSelect.value,
            fileEncoding: encodeSelect.value,
          });
        }
        props.onClickSetNextActive(true);
      } else {
        props.onClickSetNextActive(false);
      }

      if (props.modelDataId !== modelSelect.value) {
        props.getMapperTemplates({
          content_type: modelSelect.value,
        });
      }
    }
  }, [modelSelect, delimiter, encodeSelect, props.activeTab]);

  return (
    <React.Fragment>
      <Row className="justify-content-md-center">
        <Col lg={5}>
          <AvForm>
            <div className="mb-3">
              <Label htmlFor="position">Import to project</Label>
              <FormGroup className="flex-grow-1">
                <Select
                  name="project"
                  defaultValue={options[0]}
                  value={modelSelect}
                  onChange={setModel}
                  options={options}
                  classNamePrefix="select2-selection"
                  required
                />
              </FormGroup>
            </div>
            <div className="mb-3">
              <Label htmlFor="position">File encoding</Label>
              <FormGroup className="flex-grow-1">
                <Select
                  name="encoding"
                  value={encodeSelect}
                  onChange={setEncode}
                  options={[
                    { label: "UTF-8", value: "UTF-8" },
                    { label: "windows-1250", value: "windows-1250" },
                  ]}
                  classNamePrefix="select2-selection"
                  required
                />
              </FormGroup>
            </div>
            {props.file[0].path.split(".").pop() === "csv" && (
              <div className="mb-3">
                <AvField
                  name="delimiter"
                  label="Delimiter"
                  type="text"
                  value={delimiter}
                  onChange={e => setDelimiter(e.target.value)}
                  validate={{
                    required: { value: true },
                    minLength: {
                      value: 1,
                      errorMessage: "Min 1 words",
                    },
                  }}
                />
              </div>
            )}
          </AvForm>
        </Col>
      </Row>
    </React.Fragment>
  );
};

Settings.propTypes = {
  success: PropTypes.bool,
  data: PropTypes.any,
  updateModelData: PropTypes.func,
  onClickSetNextActive: PropTypes.func,
  getMapperTemplates: PropTypes.func,
  activeTab: PropTypes.node,
  file: PropTypes.any,
  modelDataId: PropTypes.any,
};

export default connect()(Settings);
